import VueCookies from "vue-cookies";
let isAdmin = false;
let claims = "";

const token = VueCookies.get("user-token");
if (token != null) {
    const tokenPayload = JSON.parse(atob(token.split(".")[1]));
    const roleMapKey = Object.keys(tokenPayload).find((key) =>
        key.toLowerCase().includes("role"),
    );
    const role = tokenPayload[roleMapKey];
    isAdmin = role.toLocaleLowerCase() == "Admin".toLocaleLowerCase();
    claims = tokenPayload.claims;
}
export default {
    token: token || "",
    roles: localStorage.getItem("user-roles") || "",
    status: "",
    user: localStorage.getItem("user-name") || "",
    claims: claims || "",
    isAdmin: isAdmin || false,
    utaPhone: localStorage.getItem("user-uta-phone") || "",
    name: localStorage.getItem("name") || "",
    branch: localStorage.getItem("branch") || "",
    plivoPhone: localStorage.getItem("user-plivo-phone") || "",
    emailAddress: localStorage.getItem("user-email") || "",
};
